import type { AttributeChangeProps } from '../../../types';
import { NumberField } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';

const CarOdometerChange = ({ updateCoverableAttribute }: AttributeChangeProps): JSX.Element => {
    const getHippoText = useHippoText();
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);

    return (
        <>
            <h6>{getHippoText('DSS-ENTER-ODOMETER-READING-TEXT')}</h6>
            <NumberField
                id="carOdometerReading"
                name="carOdometerReading"
                label={getHippoText('DSS-ENTER-ODOMETER-READING-FIELD')}
                onBlur={(e) => {
                    updateCoverableAttribute({ odometerReading: e.target.value });
                }}
                onChange={(e) => {
                    const valueIsNotEmpty = e.target.value.length > 0;
                    setIsOpcDataFilled(valueIsNotEmpty);
                }}
                disabled={isOpcFetching}
            />
        </>
    );
};

export default CarOdometerChange;
